import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Container } from './styles';
import Toast from './Toast';

const ToastRoot: React.FC = () => {
  const toastMessages = useSelector(
    (applicationState: ApplicationState) => applicationState.toastMessages
  );

  return (
    <Container>
      {toastMessages.toasts.map((msg) => (
        <Toast key={msg.id} message={msg} />
      ))}
    </Container>
  );
};

export default ToastRoot;
